export default class LocalTimeService {
  constructor(localTimeServiceInit) {
    this.offset = undefined;
    this.tick = 60 * 1000;
    this.localTimeServiceInit = null;
    this.last_tick_timestamp = undefined;
    this.timeServiceListeners = [];
    /**
     * 本地时间服务是否可用
     * 于服务器通信校对或校对失败时不可用
     *
     * @returns 是否可用
     */
    this.isAvailable = false;
    if (localTimeServiceInit && typeof localTimeServiceInit === "function") {
      // 必须为promise
      this.last_tick_timestamp = Date.now();
      this.localTimeServiceInit = localTimeServiceInit;
      // 启动对钟定时任务
      this.timeServiceTask();
      // 启动定时校对任务
      this.resetTimerServiceTask();
    }
  }

  enableTimeService() {
    this.isAvailable = true;
    this.notifyTimeServiceChange();
  }

  disableTimeService() {
    this.isAvailable = false;
    this.notifyTimeServiceChange();
  }

  notifyTimeServiceChange() {
    // 执行监听队列
    (this.timeServiceListeners || []).forEach((listener) => {
      if (listener && typeof listener === "function") {
        listener();
      }
    });
  }

  /**
   * 定时对钟任务
   * */
  timeServiceTask() {
    // 执行对钟请求
    if (
      undefined === this.offset ||
      Math.abs(Date.now() - this.last_tick_timestamp - this.tick) >= 1000
    ) {
      // 启动对钟
      this.disableTimeService();
      this.execTimeService()
        .then((res) => {
          this.enableTimeService();
          // 下一个tick再检查是否需要对钟
          this.nextTick();
        })
        .catch((err) => {
          this.isAvailable = false;
        });
    } else {
      // 下一个tick再检查是否需要对钟
      this.nextTick();
    }
    this.last_tick_timestamp = Date.now();
  }

  /**
   * 每10分钟强制更新任务
   * */
  resetTimerServiceTask() {
    setInterval(() => {
      this.disableTimeService();
      this.execTimeService()
        .then((res) => {
          this.enableTimeService();
        })
        .catch((err) => {
          this.isAvailable = false;
        });
    }, 10 * 60 * 1000);
  }

  /**
   * 下个Tick再次对钟
   * */
  nextTick() {
    const timer = setTimeout(() => {
      this.timeServiceTask();
      clearTimeout(timer);
    }, this.tick);
  }

  execTimeService() {
    // 对钟前设置服务不可用
    return new Promise((resolve, reject) => {
      if (!this.localTimeServiceInit) reject();
      const serive = this.localTimeServiceInit();
      if (serive.then) {
        serive
          .then((res) => {
            // 时差，并记录对钟
            this.offset = (Date.now() - this.last_tick_timestamp) / 2 + res.sysTime - Date.now();
            resolve({
              timestamp: Date.now() + this.offset,
            });
          })
          .catch((err) => {
            reject(err);
          });
      }
    });
  }

  /**
   * 获取经过校对的当前时间戳
   * 仅 isAvailable 为 ture 时可用
   * 时间不可用时调用，将抛出异常
   *
   * @returns 经过校对的当前时间戳
   */
  getTimestamp() {
    if (!this.isAvailable) throw new Error("time service is not available");
    return Date.now() + this.offset;
  }

  /**
   * 尝试获取经过校对的当前时间戳，时间服务不可用时，使用提供的备选值
   *
   * @param defaultValue 备选时间戳
   * @returns 经过校对的当前时间戳，或备选值
   */
  tryGetTimestamp(defaultValue) {
    if (!this.isAvailable) return defaultValue || undefined;
    return Date.now() + this.offset;
  }

  /**
   * 异步的获取经过校对的当前时间戳
   * 将在时间服务可用时异步回调，超出最大等待时间时将抛出异常
   * 不同平台编程语言有差异，异步API风格保持与平台风格一直
   *
   * @param timeout 异步任务等待的超时时间
   * @returns 异步promise回调
   */
  getTimestampAsync(timeout) {
    return new Promise((resolve, reject) => {
      this.execTimeService()
        .then((res) => {
          resolve(res.timestamp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  /**
   * 订阅时间服务可用行变化事件，可用性变化时将触发事件
   *
   * @param listener 事件监听器。事件值为触发事件时的可用性布尔值
   */
  addAvaiableChangeListener(listener) {
    this.timeServiceListeners.push(listener);
  }

  /**
   * 取消已订阅事件
   *
   * @param listener 此前订阅的事件监听器。未正确定订阅过时将抛出异常
   */
  removeAvaiableChangeListener(listener) {
    (this.timeServiceListeners || []).forEach((l, index) => {
      if (listener === l) this.timeServiceListeners.splice(index, 1);
    });
  }
}
